const PERMISSION_KEY= "crm:segments";
const PAGE_URL = {
    SEGMENTS_PAGE: "/admin/crm/segments"
}

export {PERMISSION_KEY, PAGE_URL}

